<template>
	<div ref="wrapper">	
		<div class="circle" :class="classes" :style="styles"> 
			<div class="inner">
				<v-icon color="white">{{icon}}</v-icon><br/>
				<span class="title">{{title}}</span>
			</div>
		</div>
		<p class="text" :class="`${color}--text`">{{text}}</p>
	</div>
</template>
<style lang="less" scoped>
	.circle{
		margin-left: auto;
		margin-right: auto;
		height: 40vh;
		width: 40vh;
		border-radius: 50%;
		display: table;
		padding: 10px;
		margin-bottom: 15px;
		.inner{
			display: table-cell;
			vertical-align: middle;
			font-size: 1.2em;
			text-align: center;
			color: white;
			i{
				font-size: 3em;
			}
			.title{				
				text-transform: uppercase;
				font-weight: 100;
			}
		}
	}
	.text{
		text-align: center;
		margin-left: auto;
		margin-right: auto;
		font-size: 1.4em;
		font-weight: bold;
	}
</style>
<script>
	export default {
		name: "RoundInfo", 
		props: ["title", "text", "color", "icon" ], 
		data: () => {
			return {
				wrapperWidth: null,
				styles: {
					height: "40vh", 
					width: "40vh"
				}
			}
		},
		computed: {
			classes() {
				var obj = {};
				obj[this.color] = true;
				return obj
			}
		},
		watch: {
			wrapperWidth: {
				// immediate: true,
				handler(){
					this.styles.height = `${this.wrapperWidth * 0.7 }px`;
					this.styles.width = `${this.wrapperWidth * 0.7 }px`;
				}
			}
		}, 
		methods: {
			getWidth(){
				this.wrapperWidth = this.$refs["wrapper"].offsetWidth
			}
		},
		mounted(){
			this.getWidth();
			window.addEventListener("resize", this.getWidth );
		}
	}
</script>